import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import "./saleTable.scss";

const SaleTable = ({ orders }) => {
    const calculateTotalPrice = (arr) => {
        let totalPrice = 0;
        arr.map((item) => {
            totalPrice += item.total_price;
        });
        return totalPrice;
    };

    return (
        <>
            {orders?.data.length > 0 && (
                <>
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">ID</th>
                                <th scope="col">Товари</th>
                                <th scope="col">Сума</th>
                                <th
                                    scope="col"
                                    className="no-mobile"
                                >
                                    Магазин
                                </th>
                                <th
                                    scope="col"
                                    className="no-mobile"
                                >
                                    Час
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders?.data.map((order) => {
                                return (
                                    <tr key={order.id}>
                                        <td className='percent-20"'>
                                            <Link
                                                className="table__link"
                                                to={"/order/" + order.id}
                                            >
                                                Замовлення #{order.id}
                                            </Link>
                                            {order.note.length > 0 && <div className="note">{order.note}</div>}
                                        </td>
                                        <td>
                                            <ul className="list_purchaches">
                                                {order?.products.map((product) => {
                                                    return (
                                                        <li key={product.id}>
                                                            <Link to={"/product/" + product.id}>
                                                                {product.title} ({" "}
                                                                {product.imei_sn.slice(product.imei_sn.length - 5)})
                                                                <span className="badge bg-danger">
                                                                    {product?.shipper?.title_short}
                                                                </span>
                                                            </Link>
                                                        </li>
                                                    );
                                                })}
                                                {order?.services.map((service) => {
                                                    return <li key={service.id}>{service.title}</li>;
                                                })}
                                            </ul>
                                        </td>

                                        <td className="fit">{order.total_price} грн</td>
                                        <td className="fit no-mobile">{order?.store?.title}</td>
                                        <td className="fit no-mobile">
                                            {order.completed_at ? moment(order.completed_at).format("HH:mm") : "-"}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    <div className="all_price_of_day">
                        Всього: <b>{calculateTotalPrice(orders.data)}&nbsp;грн.</b>
                    </div>
                </>
            )}
        </>
    );
};

export default SaleTable;
